import { Component, OnInit } from '@angular/core';
import { Fornecedor } from '../../../../types/Fornecedor.type';
import { FornecedorService } from '../../../../services/fornecedor.service';
import { ToastService } from '../../../../services/toast.service';

@Component({
  selector: 'app-fornecedores',
  templateUrl: './fornecedores.component.html',
  styleUrl: './fornecedores.component.css'
})
export class FornecedoresComponent implements OnInit{

  fornecedores!: Fornecedor[]
  loading: boolean = true
  constructor(private fornecedorService: FornecedorService, private toastService: ToastService){}
  loadingSincronizar: boolean = false
  

  ngOnInit(){

    this.getFornecedores();
  }

  getFornecedores(){
    this.loading = true
    this.fornecedorService.getFornecedores().subscribe((data) => {
      this.fornecedores = data
      this.loading = false
    })
  }

  atualizar(){
    this.getFornecedores();
  }

  exportar() {

    this.loadingSincronizar = true;

    this.fornecedorService
      .exportar()
      .subscribe({
        next: (value) => {
          const url = window.URL.createObjectURL(value);
          const a = document.createElement('a')
          a.href = url
          a.download = 'fornecedores.xlsx'
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        },
        error: (error) => {
          this.toastService.erro("Exportar", 'Erro ao exportar:' + error.error);
          this.loadingSincronizar = false;
        },
        complete: () => {
          this.loadingSincronizar = false;
        },
      });
  }


}
